// packages/features/scbk-shared-module/src/modules/Download/utils/tableToSheetData.ts

/**
 * HTMLTableElement을 2차원 배열로 변환한다.
 * colspan/rowspan은 첫 셀 값만 사용한다.
 */
export const tableToSheetData = (table: HTMLTableElement): (string | number | null)[][] => {
  const rows = Array.from(table.querySelectorAll('tr'));

  return rows.map((row) => {
    const cells = Array.from(row.querySelectorAll('th, td'));
    return cells.map((cell) => {
      const text = cell.textContent?.trim() ?? '';
      const num = Number(text.replace(/,/g, ''));
      return text !== '' && !Number.isNaN(num) && /^-?[\d,]+(\.\d+)?$/.test(text)
        ? num
        : text || null;
    });
  });
};
